"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    MediaGalleryClient: Symbol("MediaGalleryClient"),
    MediaGalleryRoute: Symbol("MediaGalleryRoute"),
    MediaGalleryBatchClient: Symbol("MediaGalleryBatchClient"),
    MediaGalleryBatchRoute: Symbol("MediaGalleryBatchRoute"),
    MediaGallerySettingsClient: Symbol("MediaGallerySettingsClient"),
    MediaGallerySettingsRoute: Symbol("MediaGallerySettingsRoute"),
    MediaGalleryInstanceFilesBatchClient: Symbol("MediaGalleryInstanceFilesBatchClient"),
    MediaGalleryInstanceFilesBatchRoute: Symbol("MediaGalleryInstanceFilesBatchRoute"),
    MediaGalleryInstanceFilesClient: Symbol("MediaGalleryInstanceFilesClient"),
    MediaGalleryInstanceFilesRoute: Symbol("MediaGalleryInstanceFilesRoute"),
    MediaGalleryFileStreamClient: Symbol("MediaGalleryFileStreamClient"),
    MediaGalleryFileStreamRoute: Symbol("MediaGalleryFileStreamRoute"),
    MediaGalleryFileBatchClient: Symbol("MediaGalleryFileBatchClient"),
    MediaGalleryFileBatchRoute: Symbol("MediaGalleryFileBatchRoute"),
    MediaGalleryFileClient: Symbol("MediaGalleryFileClient"),
    MediaGalleryFileRoute: Symbol("MediaGalleryFileRoute"),
    MediaGalleryFileStreamsClient: Symbol("MediaGalleryFileStreamsClient"),
    MediaGalleryFileStreamsRoute: Symbol("MediaGalleryFileStreamsRoute"),
    Root: Symbol("Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.MediaGalleryClient).to(_1.MediaGalleryClient);
    bind(TYPES.MediaGalleryRoute).to(_1.MediaGalleryRoute);
    bind(TYPES.MediaGalleryBatchClient).to(_1.MediaGalleryBatchClient);
    bind(TYPES.MediaGalleryBatchRoute).to(_1.MediaGalleryBatchRoute);
    bind(TYPES.MediaGallerySettingsClient).to(_1.MediaGallerySettingsClient);
    bind(TYPES.MediaGallerySettingsRoute).to(_1.MediaGallerySettingsRoute);
    bind(TYPES.MediaGalleryInstanceFilesBatchClient).to(_1.MediaGalleryInstanceFilesBatchClient);
    bind(TYPES.MediaGalleryInstanceFilesBatchRoute).to(_1.MediaGalleryInstanceFilesBatchRoute);
    bind(TYPES.MediaGalleryInstanceFilesClient).to(_1.MediaGalleryInstanceFilesClient);
    bind(TYPES.MediaGalleryInstanceFilesRoute).to(_1.MediaGalleryInstanceFilesRoute);
    bind(TYPES.MediaGalleryFileBatchClient).to(_1.MediaGalleryFileBatchClient);
    bind(TYPES.MediaGalleryFileBatchRoute).to(_1.MediaGalleryFileBatchRoute);
    bind(TYPES.MediaGalleryFileClient).to(_1.MediaGalleryFileClient);
    bind(TYPES.MediaGalleryFileRoute).to(_1.MediaGalleryFileRoute);
    bind(TYPES.MediaGalleryFileStreamClient).to(_1.MediaGalleryFileStreamClient);
    bind(TYPES.MediaGalleryFileStreamRoute).to(_1.MediaGalleryFileStreamRoute);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;
